import { render, staticRenderFns } from "./deleteProductGroup.vue?vue&type=template&id=f0c13b66"
import script from "./deleteProductGroup.vue?vue&type=script&lang=js"
export * from "./deleteProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports